import { ButtonLink, Heading, Inline, Stack, Text } from 'braid-design-system';
import { useEffect, useRef } from 'react';

import { LANDING_PAGE_TRACKING_EVENTS } from 'src/App/services/tracking/trackingConfig';
import { useTracking } from 'src/App/services/tracking/useTracking';

type SearchLandingPageBannerProps = {
  title: string;
  description: string;
  buttonText: string;
  href: string;
  tracking: {
    trackingKey: keyof typeof LANDING_PAGE_TRACKING_EVENTS;
    componentName: string;
    buttonComponentName: string;
  };
};

export const SearchLandingPageBanner = ({
  title,
  description,
  buttonText,
  href,
  tracking,
}: SearchLandingPageBannerProps) => {
  const trackingCallbacks = useTracking(LANDING_PAGE_TRACKING_EVENTS);
  const hasTrackedDisplayRef = useRef(false);
  const { trackingKey, componentName, buttonComponentName } = tracking;

  useEffect(() => {
    if (!hasTrackedDisplayRef.current) {
      trackingCallbacks[trackingKey].trackComponentDisplayedEvent({
        component: {
          name: componentName,
          type: 'dialog',
        },
      });
      hasTrackedDisplayRef.current = true;
    }
  }, [trackingCallbacks, trackingKey, componentName]);

  return (
    <Stack space="large">
      <Heading level="2">{title}</Heading>
      <Text>{description}</Text>
      <Inline space="none">
        <ButtonLink
          onClick={() =>
            trackingCallbacks[trackingKey].trackComponentPressedEvent({
              component: {
                name: buttonComponentName,
                type: 'button',
              },
            })
          }
          href={href}
          tone="formAccent"
          variant="solid"
        >
          {buttonText}
        </ButtonLink>
      </Inline>
    </Stack>
  );
};
